import React, { useEffect, useState } from 'react';
import { StyledLink, Value } from './styles';
import {
  PopoverMultipleLines,
  PopoverWithContent,
  POSITION,
  VALUE_STYLE,
} from '../types';
import { DynamicPopover, fontSize, KeyLabel } from '../utils';
import { useAttributionContext } from './AttributionContext';
import { HelpTip } from '@amzn/storm-ui';

export const AttributesKeyValue: React.VFC<{
  id: string;
  valueKey: string;
  value: string;
  valueStyle?: VALUE_STYLE;
  valueUrl?: string;
  toolTip?: string;
  tooltipPosition?: POSITION;
  ariaLabel?: string;
}> = ({
  id,
  valueKey,
  value,
  valueStyle,
  valueUrl,
  toolTip,
  tooltipPosition,
  ariaLabel,
}) => {
  const [dynamicDisplayText, setDynamicDisplayText] = useState(value);
  const [dynamicTooltip, setDynamicTooltip] = useState<
    string | PopoverWithContent | PopoverMultipleLines | undefined
  >(toolTip);
  const [dynamicStyle, setDynamicStyle] = useState(valueStyle);
  const textFontSize = fontSize();
  const { activationToggleData } = useAttributionContext();

  useEffect(() => {
    const updateKeyValueEvent = () => {
      if (!activationToggleData) return;
      const { attachedComponent, activationResponse } = activationToggleData;
      if (id !== attachedComponent) return;
      const { displayText, popoverContent, status } = activationResponse;
      if (displayText) setDynamicDisplayText(displayText);
      if (popoverContent) setDynamicTooltip(popoverContent);
      if (status) setDynamicStyle(status);
    };
    updateKeyValueEvent();
  }, [activationToggleData]);
  useEffect(() => {
    setDynamicDisplayText(value);
  }, [value]);

  useEffect(() => {
    setDynamicStyle(valueStyle);
  }, [valueStyle]);

  useEffect(() => {
    setDynamicTooltip(toolTip);
  }, [toolTip]);

  const KeyValueElementIA2 = () => (
    <>
      <KeyLabel label={valueKey} />
      {valueUrl ? (
        <StyledLink href={valueUrl} size={textFontSize} aria-label={ariaLabel}>
          {dynamicDisplayText}
        </StyledLink>
      ) : (
        <Value
          valueStyle={dynamicStyle}
          size={textFontSize}
          inline={true}
          renderAs="span"
        >
          {dynamicDisplayText}
        </Value>
      )}
      {dynamicTooltip && (
        <HelpTip
          tooltipProps={{ withCloseButton: false, position: tooltipPosition }}
        >
          <DynamicPopover popover={dynamicTooltip} />
        </HelpTip>
      )}
    </>
  );

  return <KeyValueElementIA2 />;
};
